module.exports = __webpack_public_path__ + "static/img/2.64acfbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/eng/2.png
// module id = AivU
// module chunks = 0